import ManageReels from "../pages/Reels/ManageReels";
import AddReel from "../pages/Reels/AddReel";
import EditReel from "../pages/Reels/EditReel";
import { ParamsProvider, useLocation } from "../router";

/**
 * Reels screens under /reels, /reels/add, /reels/edit/:id
 */
const ReelsRoutes = () => {
  const { pathname } = useLocation();

  if (pathname === "/reels/add") {
    return <AddReel />;
  }

  const editMatch = pathname.match(/^\/reels\/edit\/([^/]+)$/);
  if (editMatch) {
    return (
      <ParamsProvider params={{ id: editMatch[1] }}>
        <EditReel />
      </ParamsProvider>
    );
  }

  return <ManageReels />;
};

export default ReelsRoutes;
